import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { TranslatePipe } from "@pipes";
import { CurrencyService } from "@services";

import { ButtonComponent } from "../button/button.component";
import { CalculatorComponent } from "../calculator/calculator.component";
import { ModalInstance, ModalWithData } from "../modal/modal.interfaces";
import { ModalService } from "../modal/modal.service";
import { SvgComponent } from "../svg/svg.component";

interface Data {
  min: string;
  max: string;
}

@Component({
  styleUrls: ["./calculator-modal.component.scss"],
  templateUrl: "./calculator-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CalculatorComponent, ButtonComponent, TranslatePipe, SvgComponent],
})
export class CalculatorModalComponent implements ModalWithData<Data> {
  private readonly mS = inject(ModalService);
  private readonly crS = inject(CurrencyService);

  public data: Data;
  public instance: ModalInstance<Data>;

  public amount = "0";
  public prefix = this.crS.symbol;
  public precision = this.crS.precision;

  public close(apply?: boolean): void {
    this.mS.close(this.instance, apply);
  }
}
